var _objectWithoutProperties = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _classCallCheck = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/createClass.js");

var _assertThisInitialized = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _taggedTemplateLiteral = require("/codebuild/output/src3963077387/src/alisi-website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["id", "label", "onBlur", "onFocus", "type", "refs", "className"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('styled-components')) : typeof define === 'function' && define.amd ? define(['react', 'styled-components'], factory) : (global = global || self, global.FloatingLabelInput = factory(global.React, global.styled));
})(this, function (React, styled) {
  'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  styled = styled && styled.hasOwnProperty('default') ? styled['default'] : styled;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var FloatingLabelInput = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
  var FloatingLabelInputContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  position: relative;\n  height: 2em;\n  border-bottom: 1px solid #ddd;\n  font-size: inherit;\n"])));
  var FloatingLabel = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  border: 0;\n  position: absolute;\n  color: #9b9b9b;\n  bottom: 0;\n  transition: all 0.2s ease-in-out;\n  transform-origin: left top;\n  font-size: 1em;\n  cursor: text;\n  pointer-events: none;\n  width: 66.6%;\n  transform: ", ";\n"])), function (props) {
    return props.active ? 'translate3d(0, -70%, 0) scale(0.70)' : 'none';
  });
  var FloatingInput = styled.input(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  border: none;\n  outline: none;\n  font-size: 1em;\n  &::placeholder {\n    color: #9b9b9b;\n    opacity: ", ";\n    transition: opacity 0.2s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  }\n"])), function (props) {
    return props.active ? 1 : 0;
  });

  var TextInput = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(TextInput, _React$PureComponent);

    var _super = _createSuper(TextInput);

    function TextInput(props) {
      var _this;

      _classCallCheck(this, TextInput);

      _this = _super.call(this, props);

      if (!props.id && !props.name) {
        throw new Error('expected id but none present');
      }

      _this.state = {
        active: props.value && props.value.length > 0
      };
      _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
      _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(TextInput, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.active && this.props.value && prevProps.value !== this.props.value) {
          this.setState({
            active: true
          });
        }
      }
    }, {
      key: "onFocus",
      value: function onFocus(event) {
        this.setState({
          active: true
        });

        if (this.props.onFocus) {
          this.props.onFocus(event);
        }
      }
    }, {
      key: "onBlur",
      value: function onBlur(event) {
        this.setState({
          active: event.target.value.length !== 0
        });

        if (this.props.onBlur) {
          this.props.onBlur(event);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            id = _this$props.id,
            label = _this$props.label,
            onBlur = _this$props.onBlur,
            onFocus = _this$props.onFocus,
            type = _this$props.type,
            refs = _this$props.refs,
            className = _this$props.className,
            otherProps = _objectWithoutProperties(_this$props, _excluded);

        var active = this.state.active;
        return React.createElement(FloatingLabelInput, null, React.createElement(FloatingLabelInputContainer, {
          className: className
        }, React.createElement(FloatingLabel, {
          className: className,
          htmlFor: id,
          active: active
        }, label), React.createElement(FloatingInput, _extends({
          active: active,
          className: className,
          id: id,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          ref: refs,
          type: type
        }, otherProps))));
      }
    }]);

    return TextInput;
  }(React.PureComponent);

  return TextInput;
});